/* OUUUTLET gate (plan 023).
 * Runs on outlet collection pages. Reads window.SuuuOutlet (set by the inline
 * head script), keeps the state classes on <html> current every second,
 * renders the countdown, and handles the password form: SHA-256 of the input
 * is compared with the hash rendered from theme settings; on match a cookie
 * holding that hash is set until the closing time and the grid is revealed.
 * This is a curtain, not a lock: Liquid cannot read cookies. */
(function () {
  if (customElements.get('outlet-gate')) return;

  var STATES = ['outlet-state-before', 'outlet-state-open', 'outlet-state-closed'];

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  var GLYPHS = 'abcdefghijklmnopqrstuvwxyz0123456789#%&@$*+=/<>';

  /* Matrix-style text swap: every character cycles through random glyphs and
   * settles on the target, left to right with a little jitter. Resolves when
   * the whole line reads `text`. */
  function scramble(el, text, duration) {
    duration = duration || 700;
    return new Promise(function (resolve) {
      var from = el.textContent;
      var length = Math.max(from.length, text.length);
      var start = performance.now();
      var order = [];
      for (var i = 0; i < length; i++) order.push(i / Math.max(1, length - 1) * 0.7 + Math.random() * 0.3);
      // timer-driven (not requestAnimationFrame) so the flow also completes
      // when the tab is briefly hidden — the promise must always resolve
      var timer = setInterval(function () {
        var t = Math.min(1, (performance.now() - start) / duration);
        var out = '';
        for (var i = 0; i < length; i++) {
          var target = text[i] || '';
          if (target === ' ') { out += ' '; continue; }
          if (t >= order[i]) out += target;
          else if (target === '' && t > 0.5) out += '';
          else out += GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
        }
        el.textContent = out;
        if (t >= 1) {
          clearInterval(timer);
          el.textContent = text;
          resolve();
        }
      }, 40);
    });
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function sha256Hex(text) {
    var data = new TextEncoder().encode(text);
    return crypto.subtle.digest('SHA-256', data).then(function (buf) {
      var bytes = new Uint8Array(buf);
      var hex = '';
      for (var i = 0; i < bytes.length; i++) hex += bytes[i].toString(16).padStart(2, '0');
      return hex;
    });
  }

  function parts(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    return {
      d: Math.floor(total / 86400),
      h: Math.floor((total % 86400) / 3600),
      m: Math.floor((total % 3600) / 60),
      s: total % 60
    };
  }

  /* Countdown to the opening (data-target="opens") or closing time
   * (data-target="closes", default). Used by the product-page bar. When the
   * closing time passes, the page is reloaded so the head script applies the
   * closed state (redirect to the landing collection). */
  class OutletCountdown extends HTMLElement {
    connectedCallback() {
      var ctx = window.SuuuOutlet;
      this.config = ctx && ctx.config;
      if (!this.config) return;
      this.target = this.dataset.target === 'opens' ? this.config.opensAt : this.config.closesAt;
      this.values = {};
      var self = this;
      ['d', 'h', 'm', 's'].forEach(function (u) {
        self.values[u] = self.querySelector('[data-unit="' + u + '"]');
      });
      this.days = this.querySelector('[data-days]');
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      var now = Math.max(Date.now(), this.config.serverNow || 0);
      var remaining = this.target - now;
      if (remaining <= 0) {
        clearInterval(this.timer);
        if (this.dataset.target !== 'opens') location.replace(this.config.landing);
        return;
      }
      var p = parts(remaining);
      if (this.days) this.days.hidden = p.d === 0;
      if (this.values.d) this.values.d.textContent = String(p.d);
      if (this.values.h) this.values.h.textContent = pad(p.h);
      if (this.values.m) this.values.m.textContent = pad(p.m);
      if (this.values.s) this.values.s.textContent = pad(p.s);
    }
  }

  customElements.define('outlet-countdown', OutletCountdown);

  /* Title of an unlocked outlet collection ("ouuutlet"): the letters never
   * change size — only the NUMBER of u's does. One run, at random intervals:
   * u's are added one by one up to the maximum that fits beside the
   * countdown, held, then removed one by one back to normal. What varies
   * between runs is only the timing: total duration (2–3s) and the easing of
   * the steps, chosen independently for the way up and the way down. */
  class OutletTitle extends HTMLElement {
    connectedCallback() {
      this.run = this.querySelector('.outlet-hero__us');
      this.base = parseInt(this.dataset.base, 10) || 0;
      if (!this.run || !this.base || this.hasAttribute('data-static')) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.max = 0;
      var self = this;
      this.onResize = function () { self.max = 0; };
      window.addEventListener('resize', this.onResize);
      this.idle();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      window.removeEventListener('resize', this.onResize);
    }

    /* how many u's fit: (available width - width without u's) / width of one u.
     * Measured lazily, when the title is actually visible (the hero is
     * display:none while the gate is locked, so widths are 0 at connect time). */
    measure() {
      var title = this.closest('.outlet-hero__title') || this.parentElement;
      var available = title.getBoundingClientRect().width;
      // column layout (mobile): the title box may hug the word; use the hero row width instead
      var hero = this.closest('.outlet-hero');
      var countdown = hero && hero.querySelector('.outlet-hero__countdown');
      if (hero && countdown && countdown.getBoundingClientRect().top >= title.getBoundingClientRect().bottom - 1) {
        available = hero.getBoundingClientRect().width;
      }
      var count = Math.max(1, this.run.textContent.length);
      var uWidth = this.run.getBoundingClientRect().width / count;
      if (!available || !uWidth) return false;
      var restWidth = this.getBoundingClientRect().width - uWidth * count;
      // as many as fit in the space left beside the countdown (the title box
      // clips, so a rounding slip only trims the last u)
      var max = Math.floor((available - restWidth) / uWidth);
      this.max = Math.max(this.base + 1, max);
      return true;
    }

    set(n) {
      if (!isFinite(n)) return;
      this.run.textContent = new Array(Math.max(0, Math.round(n)) + 1).join('u');
    }

    idle() {
      var self = this;
      this.timer = setTimeout(function () { self.play(); }, 4500 + Math.random() * 9000);
    }

    play() {
      if (!this.max && !this.measure()) {
        this.idle();
        return;
      }
      var names = Object.keys(OutletTitle.easings);
      // always fill the available width; only the timing varies between runs
      var target = this.max;
      var up = OutletTitle.easings[names[Math.floor(Math.random() * names.length)]];
      var down = OutletTitle.easings[names[Math.floor(Math.random() * names.length)]];
      // whole run (up + hold + down) lasts 2–3s: split a random total
      var total = 2000 + Math.random() * 1000;
      var hold = 250 + Math.random() * 250;        // pause at the top
      var upShare = 0.45 + Math.random() * 0.15;   // 45–60% of the rest goes up
      var upTime = (total - hold) * upShare;       // total time to reach the target
      var downTime = total - hold - upTime;        // total time back to normal
      var steps = [];
      var extra = target - this.base;
      var i;
      for (i = 1; i <= extra; i++) {
        steps.push([this.base + i, Math.round((up(i / extra) - up((i - 1) / extra)) * upTime)]);
      }
      for (i = 1; i <= extra; i++) {
        steps.push([target - i, Math.round((down(i / extra) - down((i - 1) / extra)) * downTime) + (i === 1 ? hold : 0)]);
      }
      this.step(steps, 0);
    }

    step(steps, i) {
      var self = this;
      if (i >= steps.length) {
        this.set(this.base);
        this.idle();
        return;
      }
      this.timer = setTimeout(function () {
        self.set(steps[i][0]);
        self.step(steps, i + 1);
      }, Math.max(25, steps[i][1]));
    }
  }

  /* cumulative time curves: t = share of the steps done → share of the total
   * time elapsed. Named after how the u's appear to the eye. */
  OutletTitle.easings = {
    steady: function (t) { return t; },
    fastThenSlow: function (t) { return t * t; },
    slowThenFast: function (t) { return 1 - (1 - t) * (1 - t); },
    fastSlowFast: function (t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; },
    burstThenSettle: function (t) { return t * t * t; },
    windUp: function (t) { return 1 - Math.pow(1 - t, 3); }
  };

  customElements.define('outlet-title', OutletTitle);

  class OutletGate extends HTMLElement {
    connectedCallback() {
      var ctx = window.SuuuOutlet;
      this.config = ctx && ctx.config;
      if (!this.config) return;

      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="password"]');
      this.button = this.querySelector('button[type="submit"]');
      this.error = this.querySelector('.outlet-gate__error');
      this.status = this.querySelector('.outlet-gate__status');
      this.busy = false;
      this.values = {};
      var self = this;
      ['d', 'h', 'm', 's'].forEach(function (u) {
        self.values[u] = self.querySelector('[data-unit="' + u + '"]');
      });
      this.fails = 0;

      this.form.addEventListener('submit', this.onSubmit.bind(this));
      // Explicit Enter handling: some embedded browsers skip implicit submission.
      this.input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          self.onSubmit(event);
        }
      });
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    now() {
      // serverNow is a floor: a slow device clock can never keep the gate shut
      // past Shopify's own time. Date.now() advances; serverNow does not.
      return Math.max(Date.now(), this.config.serverNow || 0);
    }

    state() {
      var now = this.now();
      if (now < this.config.opensAt) return 'before';
      if (now < this.config.closesAt) return 'open';
      return 'closed';
    }

    tick() {
      var st = this.state();
      var html = document.documentElement;
      var cls = 'outlet-state-' + st;
      if (!html.classList.contains(cls)) {
        STATES.forEach(function (c) { html.classList.remove(c); });
        html.classList.add(cls);
        if (st !== 'open') html.classList.remove('outlet-unlocked');
        if (st === 'open' && this.input) this.input.focus({ preventScroll: true });
      }
      if (st === 'before') this.renderCountdown(this.config.opensAt - this.now());
    }

    renderCountdown(ms) {
      var p = parts(ms);
      if (this.values.d) {
        this.values.d.textContent = String(p.d);
        var dayUnit = this.values.d.closest('.outlet-gate__unit');
        if (dayUnit) dayUnit.hidden = p.d === 0;
      }
      if (this.values.h) this.values.h.textContent = pad(p.h);
      if (this.values.m) this.values.m.textContent = pad(p.m);
      if (this.values.s) this.values.s.textContent = pad(p.s);
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.state() !== 'open' || this.button.disabled || this.busy) return;
      var value = (this.input.value || '').trim();
      if (!value) return;
      if (!window.crypto || !crypto.subtle || !window.TextEncoder) {
        this.showError(this.error.dataset.unsupported);
        return;
      }
      var self = this;
      var st = this.status;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var say = function (key, duration) {
        if (!st) return Promise.resolve();
        if (reduced) { st.textContent = st.dataset[key]; return Promise.resolve(); }
        return scramble(st, st.dataset[key], duration);
      };
      this.busy = true;
      this.error.hidden = true;
      this.button.disabled = true;
      this.input.blur();
      // "checking password" runs while the hash is computed, then the verdict
      Promise.all([say('checking', 700).then(function () { return wait(350); }), sha256Hex(value)])
        .then(function (results) {
          var hex = results[1];
          if (self.config.hash && hex === self.config.hash) {
            return say('granted', 600).then(function () { return wait(450); })
              .then(function () { return say('opening', 600); })
              .then(function () { return wait(500); })
              .then(function () { self.unlock(hex); });
          }
          return say('denied', 500).then(function () {
            self.fail();
            return wait(900);
          }).then(function () { return say('locked', 500); });
        })
        .catch(function () {
          self.showError(self.error.dataset.unsupported);
          if (st) st.textContent = st.dataset.locked;
        })
        .then(function () {
          self.busy = false;
          if (!self.lockout) self.button.disabled = false;
        });
    }

    unlock(hex) {
      var expires = new Date(this.config.closesAt).toUTCString();
      var cookie = 'suuu_outlet=' + encodeURIComponent(hex) + '; Path=/; Expires=' + expires + '; SameSite=Lax';
      if (location.protocol === 'https:') cookie += '; Secure';
      document.cookie = cookie;
      document.documentElement.classList.add('outlet-just-unlocked');
      document.documentElement.classList.add('outlet-unlocked');
      this.error.hidden = true;
      this.input.value = '';

      // Came from a locked product page: send them back there.
      var back = null;
      try {
        back = sessionStorage.getItem('suuu_outlet_return');
        if (back) sessionStorage.removeItem('suuu_outlet_return');
      } catch (e) {}
      if (back && back.indexOf('/') === 0) {
        location.assign(back);
        return;
      }

      // Page was rendered before the opening time (no grid in the HTML):
      // fetch a fresh render with a new cache key.
      if (!document.querySelector('.outlet-gated-content')) {
        location.assign(location.pathname + '?o=' + Date.now());
      }
    }

    fail() {
      this.fails += 1;
      this.showError(this.error.dataset.wrong);
      this.classList.remove('outlet-gate--shake');
      void this.offsetWidth; // restart the animation
      this.classList.add('outlet-gate--shake');
      this.input.select();
      if (this.fails >= 5) {
        this.fails = 0;
        this.lockout = true;
        this.button.disabled = true;
        var self = this;
        setTimeout(function () { self.lockout = false; self.button.disabled = false; }, 10000);
      }
    }

    showError(text) {
      this.error.textContent = text;
      this.error.hidden = false;
    }
  }

  customElements.define('outlet-gate', OutletGate);

  /* "N products or more = X% off" widget (snippets/outlet-offer.liquid).
   * Informational only — the discount is applied by the Bundle Bear app.
   * Counts the outlet units in the cart: /cart.js items carry no product
   * tags, so the count comes from the Section Rendering API
   * (sections/outlet-cart-count.liquid). The theme has no pub/sub: a refresh
   * is triggered by the upsell's cart:* events, by the header cart bubble
   * being re-rendered (product-form and cart-drawer both do that after
   * /cart/add and /cart/change), on tab focus, and by a 5s /cart.js poll
   * while the page is visible (apps that change the cart on their own). */
  class OutletOffer extends HTMLElement {
    connectedCallback() {
      this.box = this.querySelector('.outlet-offer__box');
      this.heading = this.querySelector('.outlet-offer__heading');
      this.progress = this.querySelector('.outlet-offer__progress');
      this.count = this.querySelector('.outlet-offer__count');
      this.tip = this.querySelector('.outlet-offer__tip');
      if (!this.box || !this.heading) return;
      this.threshold = parseInt(this.dataset.threshold, 10) || 3;
      this.qty = parseInt(this.dataset.qty, 10) || 0;
      this.signature = null;
      this.pending = false;
      this.dirty = false;
      this.touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
      document.documentElement.classList.add('outlet-offer-on');

      var self = this;
      this.box.addEventListener('click', this.onClick.bind(this));
      this.onKeydown = function (event) {
        if (event.key === 'Escape' && self.classList.contains('outlet-offer--tip')) self.showTip(false);
      };
      document.addEventListener('keydown', this.onKeydown);
      this.onDocumentClick = function (event) {
        if (!self.contains(event.target)) self.showTip(false);
      };
      document.addEventListener('click', this.onDocumentClick);

      this.onCartEvent = function () { self.refresh(); };
      ['cart:updated', 'cart:change', 'cart:build'].forEach(function (name) {
        document.addEventListener(name, self.onCartEvent);
      });
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && window.MutationObserver) {
        this.observer = new MutationObserver(this.onCartEvent);
        this.observer.observe(bubble, { childList: true, subtree: true, characterData: true });
      }
      this.onVisible = function (event) {
        if (document.hidden) return;
        // bfcache restore or tab focus: the cart may have changed elsewhere
        if (!event || event.type !== 'pageshow' || event.persisted) self.poll();
      };
      document.addEventListener('visibilitychange', this.onVisible);
      window.addEventListener('pageshow', this.onVisible);
      this.timer = setInterval(function () {
        if (!document.hidden) self.poll();
      }, 5000);
      // mobile bar: expose its height so the page and the sticky add-to-cart clear it
      this.onResize = function () { self.measure(); };
      window.addEventListener('resize', this.onResize);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.onResize);
      this.measure();
    }

    measure() {
      var h = this.box.offsetHeight;
      if (h) document.documentElement.style.setProperty('--outlet-offer-h', h + 'px');
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.debounce);
      if (this.observer) this.observer.disconnect();
      var self = this;
      ['cart:updated', 'cart:change', 'cart:build'].forEach(function (name) {
        document.removeEventListener(name, self.onCartEvent);
      });
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('visibilitychange', this.onVisible);
      window.removeEventListener('pageshow', this.onVisible);
      window.removeEventListener('resize', this.onResize);
      document.documentElement.style.removeProperty('--outlet-offer-h');
      document.documentElement.classList.remove('outlet-offer-on');
    }

    onClick(event) {
      // touch: first tap shows the explanation, a second tap goes to the cart
      if (this.touch && !this.classList.contains('outlet-offer--tip')) {
        event.preventDefault();
        this.showTip(true);
        return;
      }
      var drawer = document.querySelector('cart-drawer');
      if (this.dataset.cartType === 'drawer' && drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        this.showTip(false);
        drawer.open(this.box);
      }
    }

    showTip(on) {
      this.classList.toggle('outlet-offer--tip', !!on);
    }

    /* cheap change detection between theme events: /cart.js, then the
     * section render only when the line items actually changed */
    poll() {
      var self = this;
      fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var signature = cart.items.map(function (item) { return item.id + ':' + item.quantity; }).join(',');
          if (signature === self.signature) return;
          var first = self.signature === null;
          self.signature = signature;
          // first poll: the server-rendered count is trusted unless the cart
          // changed since the page was rendered (e.g. in another tab)
          if (!first || String(cart.item_count) !== self.dataset.itemCount) self.refresh();
        })
        .catch(function () {});
    }

    refresh() {
      var self = this;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(function () { self.load(); }, 150);
    }

    load() {
      if (this.pending) {
        this.dirty = true;
        return;
      }
      var self = this;
      this.pending = true;
      fetch(this.dataset.countUrl, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.getElementById('outlet-cart-count');
          if (!node) return;
          var data = JSON.parse(node.textContent);
          if (typeof data.outletQty === 'number') self.update(data.outletQty);
          if (typeof data.itemCount === 'number') self.dataset.itemCount = String(data.itemCount);
        })
        .catch(function () {})
        .then(function () {
          self.pending = false;
          if (self.dirty) {
            self.dirty = false;
            self.load();
          }
        });
    }

    update(qty) {
      if (qty === this.qty) return;
      this.qty = qty;
      this.dataset.qty = String(qty);
      var active = qty >= this.threshold;
      var wasActive = this.classList.contains('outlet-offer--active');
      this.classList.toggle('outlet-offer--active', active);
      if (active && !wasActive) {
        var self = this;
        this.classList.add('outlet-offer--pop');
        setTimeout(function () { self.classList.remove('outlet-offer--pop'); }, 700);
      }
      var d = this.dataset;
      if (active) {
        this.heading.innerHTML = '<span class="outlet-offer__line outlet-offer__line--1"></span>';
        this.heading.firstChild.textContent = d.headingActive;
      } else {
        this.heading.innerHTML = '<span class="outlet-offer__line outlet-offer__line--1"></span><span class="outlet-offer__line outlet-offer__line--2"></span>';
        this.heading.firstChild.textContent = d.headingTop;
        this.heading.lastChild.textContent = d.headingBottom;
      }
      if (this.tip) this.tip.textContent = active ? d.tipActive : d.tip;
      if (this.count) {
        this.count.textContent = (active ? d.progressActive : d.progress).replace('__COUNT__', String(qty));
      }
      if (this.progress) {
        var segments = this.progress.querySelectorAll('.outlet-offer__seg');
        for (var i = 0; i < segments.length; i++) {
          segments[i].classList.toggle('outlet-offer__seg--on', i < qty);
        }
      }
      this.measure();
    }
  }

  customElements.define('outlet-offer', OutletOffer);
})();
